// extracted by mini-css-extract-plugin
module.exports = {"selectors":"RubricPreviews_selectors__2lPG8"};